module.exports = __webpack_public_path__ + "static/img/m3m2i2.49ec033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/m3m2i2.png
// module id = 0L7r
// module chunks = 1